import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Guid } from "@/Common/Models/Guid";
import { QuestionnaireStatusInfo } from "./QuestionnaireStatusInfo";

class QuestionnaireNotice {
    public AppointmentId: string;
    public AppointmentStartDate: Date;
    public AppointmentStatusLookupId: string;
    public ProviderContactFacetId: Guid;

    public QuestionnaireId: string;
    public QuestionnaireInstanceId: string;
    public QuestionnaireResult: boolean;

    public AppointmentPatientNameStr: string;

    public PatientContactId: Guid;
    public PatientFirstName: string;
    public PatientLastName: string;
    public PatientPreferredName: string;
    public PatientNAM: string;
    public PatientPhoneNumbers: PhoneNumber[];
    public PatientContactedDate: Date;

    constructor(field?: Partial<QuestionnaireNotice>) {
        Object.assign(this, field);
    }

    public get HasPatientProfile(): boolean {
        return !!this.PatientContactId;
    }

    public get Questionnaire(): QuestionnaireStatusInfo {
        return new QuestionnaireStatusInfo({
            AppointmentId: this.AppointmentId,
            QuestionnaireId: this.QuestionnaireId,
            QuestionnaireInstanceId: this.QuestionnaireInstanceId,
            Result: this.QuestionnaireResult,
            AppointmentDate: this.AppointmentStartDate
        });
    }
}

export { QuestionnaireNotice };
